let orderLimitError: string | null = null
let validationCallbacks: Array<() => void> = []

export const setSimulationOrderLimitError = (error: string | null) => {
  orderLimitError = error

  validationCallbacks.forEach(callback => {
    callback()
  })
}

export const getSimulationOrderLimitError = (): string | null => {
  return orderLimitError
}

export const clearSimulationOrderLimitError = () => {
  orderLimitError = null
}

export const registerValidationCallback = (callback: () => void) => {
  validationCallbacks.push(callback)
  return () => {
    validationCallbacks = validationCallbacks.filter(cb => cb !== callback)
  }
}
